export default {
  install(Vue, options) {
    Vue.prototype.$GoogleMap = {
      FMap:'',
      MapclickListen:false,
      DistanceOverlayMarkers:[],
      UnitOverlayMarkers:[],
      HistoryOverlayMarkers:[],
      HistoryAccOverlayMarkers:[],
      HistoryUnitMarker:[],
      CameraMarkers:[],
      POIMarkers:[],
      DistanceMarkernum:0,
      PolyPath:'',
      HistoryPolyPath:'',
      PolylinePoint:[],
      HistoryTracelatlngs:[],
      KmArr:[],
      KmTotal:[],
      MiArr:[],
      MiTotal:[],
      bounds:'',
      loc:'',
      POIsrc:'',
      MapLight:[

      ],
      MapDark:[//Googlemap深色樣式
        {
            "featureType": "all",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#242f3e"
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#746855"
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#242f3e"
                }
            ]
        },
        {
            "featureType": "administrative.locality",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#d59563"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#d59563"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#263c3f"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#6b9a76"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#38414e"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#212a37"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9ca5b3"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#746855"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#1f2835"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#f3d19c"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#2f3948"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#d59563"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#17263c"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#515c6d"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#17263c"
                }
            ]
        }
      ],
      Circles:[],
      Polygons:[],
      //Test Google Geofence
      // getAddress(){
      //   var geocoder = new google.maps.Geocoder();
      //   // google.maps.LatLng 物件
      //   var coord = new google.maps.LatLng(35.1472304,136.8562712);

      //   // 傳入 latLng 資訊至 geocoder.geocode
      //   geocoder.geocode({'latLng': coord }, function(results, status) {
      //     if (status === google.maps.GeocoderStatus.OK) {
      //       // 如果有資料就會回傳
      //       if (results) {
      //         console.log(results[0]);
      //       }
      //     }
      //     // 經緯度資訊錯誤
      //     else {
      //       alert("Reverse Geocoding failed because: " + status);
      //     }
      //   });
      // },
      //多車鎖定
      Multifocus:function(WatchUnitsLatLng) {
        if(WatchUnitsLatLng.length != 0){
          this.bounds = new google.maps.LatLngBounds();
          for (var i = 0; i < WatchUnitsLatLng.length; i++) {
              this.loc = new google.maps.LatLng(WatchUnitsLatLng[i].latitude, WatchUnitsLatLng[i].longitude)
              this.bounds.extend(this.loc);
          }
          this.FMap.fitBounds(this.bounds);
          //FMap.panToBounds(FThisObj.bounds);
        }
      },
      //latlng array fitbounds
      fitBounds(bounds){
        this.bounds = new google.maps.LatLngBounds();
        if(bounds){
          for(var i = 0 ; i < bounds.length;i++){
            this.loc = new google.maps.LatLng(bounds[i][0], bounds[i][1])
            this.bounds.extend(this.loc);
          }
        }
        this.FMap.fitBounds(this.bounds);
      },
      //設定地圖中心
      SetCenter:function(Lat,Lng,Zoom){
        // console.log(this.FMap.zoom)
        // console.log(Zoom)
        //if(Zoom > this.FMap.zoom){
          this.FMap.setZoom(Zoom)
        //}
        this.FMap.setCenter({ lat: Lat, lng: Lng})
      },
      //更換地圖深淺色
      SetMapStyles(color){
        var this_ = this
        switch (color) {
          case 'black':
            this.FMap.setOptions({
              styles: this_.MapDark
            });
            break;
          case 'white':
            this.FMap.setOptions({
              styles: []
            });
            break;
          default:
            break;
        }
      },
      //初始畫地圖
      InitMap(Tag, Latitude, Longitude, Zoom) {
        var streetView = false
        if(Vue.prototype.$Global.authorityDefine['GL01']){
          streetView = true
        }
        this.FMap = new google.maps.Map(document.getElementById(Tag), {
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.TOP_CENTER,
          },
          zoom: Zoom,
          center: { lat: Latitude, lng: Longitude },
          streetViewControl: streetView,
        });
        // const trafficLayer = new google.maps.TrafficLayer();
        // trafficLayer.setMap(this.FMap);
        this.SetMapStyles(localStorage.getItem('theme'))
        // console.log(this.FMap.zoom)
        // console.log(this.FMap.center.lat())
        // console.log(this.FMap.center.lng())
        this.Initpolyline('blue',this.PolylinePoint)
        //讀取kml
        // const ctaLayer = new google.maps.KmlLayer({
        //   url: "https://drive.google.com/u/0/uc?id=17BzT6lnldy_2g2vM68IDAx7PaqUKYKNe&export=download",
        //   map: this.FMap,
        // });
      },
      //計算量測距離 公里及英哩
      CalculateKmMi(){
        if(this.PolylinePoint.length > 1){
          this.KmArr.push(Vue.prototype.$Global.distance(this.PolylinePoint[this.PolylinePoint.length-2].lat,this.PolylinePoint[this.PolylinePoint.length-2].lng,this.PolylinePoint[this.PolylinePoint.length-1].lat,this.PolylinePoint[this.PolylinePoint.length-1].lng,'K').toFixed(2))
          this.MiArr.push(Vue.prototype.$Global.distance(this.PolylinePoint[this.PolylinePoint.length-2].lat,this.PolylinePoint[this.PolylinePoint.length-2].lng,this.PolylinePoint[this.PolylinePoint.length-1].lat,this.PolylinePoint[this.PolylinePoint.length-1].lng,'N').toFixed(2))
          this.KmTotal.push(this.CaculateKmTotal().toFixed(2))
          this.MiTotal.push(this.CaculateMiTotal().toFixed(2))
        }else{
          this.KmArr.push('0.00')
          this.MiArr.push('0.00')
          this.KmTotal.push('0.00')
          this.MiTotal.push('0.00')
        }
      },
      //計算量測距離 累加及英哩
      CaculateMiTotal(){
        var MiTotalnum = 0
        for(var i=0;i<this.MiArr.length;i++){
          MiTotalnum = MiTotalnum + parseFloat(this.MiArr[i])
        }
        return MiTotalnum
      },
      //計算量測距離 累加及公里
      CaculateKmTotal(){
        var KmTotalnum = 0
        for(var i=0;i<this.KmArr.length;i++){
          KmTotalnum = KmTotalnum +parseFloat(this.KmArr[i])
        }
        return KmTotalnum
      },
      //新增車機 發動 熄火點位
      AddHistoryAccOnOffMarker(div,MarkerObj,index){
        var id = 'HistoryEventMarker'+ MarkerObj.positionLogId
        var color =''
        if(MarkerObj.reportId == 11){
          switch (MarkerObj.accState) {
            case true:
              // console.log('ACC On')
              // this.AccOnOffciLayer
              color = 'green'
              break;
            case false:
              // console.log('ACC Off')
              // this.AccOnOffciLayer
              color = 'blue'
              break;            
            default:
              break;
          }
        }else{
          color = 'red'
        }
        div.classList.add("Historymarkdiv")
        var HTML;
        var src = require(`../static/images/GoogleMapICON/Row2/`+color+`.png`)
        //箭頭icon
        HTML = `<div style="position:relative"><img id="`+id+`" style="position:absolute;top:-32px;left:-16px;cursor:pointer" src="`+src+`"></div>`
        div.innerHTML = HTML
        this.AddHistoryMarkerEvent(id,index)
      },
      //新增歷史軌跡 箭頭點位
      AddHistoryMark(div,MarkerObj,index){
        var id = 'HistoryMarker'+ MarkerObj.positionLogId
        div.classList.add("Historymarkdiv")
        var HTML;
        switch (MarkerObj.arrowColor) {
          case 'red':
            MarkerObj.colornum = '6'
            break;
          case 'orange':
            MarkerObj.colornum = '5'
            break; 
          case 'green':
            MarkerObj.colornum = '1'
            break;
          case 'yellow':
            MarkerObj.colornum = '4'
            break;               
          default:
            break;
        }
        var src = require("../static/images/MapIcon/Arrow/CHeadN_s"+MarkerObj.colornum+".gif")
        //箭頭icon
        HTML = `<div style="background-color:transparent;height:10px;width:10px;border-radius:10px;position:relative;"><img src="`+src+`" id="`+id+`" style="position:absolute;top:-12.5px;left:-12.5px;transform:rotate(`+MarkerObj.direction+`deg)"></div>`
        div.innerHTML = HTML
        this.AddHistoryMarkerEvent(id,index)
      },
      //新增歷史軌跡 箭頭icon click event
      AddHistoryMarkerEvent(id,index){
        setTimeout(() => {
          Vue.prototype.$("#"+id).click(function(){
            Vue.prototype.$History.HistoryCurrentNum = index+1
          })
        }, 20);
      },
      //新增歷史軌跡事件camera點位 click event
      AddHistoryCameraEvent(HistoryMarkeid,HistoryMarkerObj){
        setTimeout(() => {
          Vue.prototype.$("#"+HistoryMarkeid).click(function(){
            //4channel的時候要改
            for(var i = 1 ; i <=16 ; i++){
              if(HistoryMarkerObj['upload'+i] == undefined){
                break;
              }else if(HistoryMarkerObj['upload'+i] != 0){
                Vue.prototype.$History.OpenEventVideo(HistoryMarkerObj,i-1)
              }
            }
            // if(HistoryMarkerObj.upload1 !=0){
            //   Vue.prototype.$Vehicle.OpenEventVideo(HistoryMarkerObj,0)
            // }
            // if(HistoryMarkerObj.upload2 !=0){
            //   Vue.prototype.$Vehicle.OpenEventVideo(HistoryMarkerObj,1)
            // }
          })
        }, 100);
      },
      //新增歷史軌跡車機 點位
      AddHistoryUnitMark(div,MarkerObj){
        //console.log(MarkerObj)
        var colornum;
        switch (MarkerObj.color) {
          case 'red':
            colornum = 6
            break;
          case 'green':
            colornum = 1
            break;       
          case 'orange':
            colornum = 5
            break;
          default:
            colornum =1
            break;
        }
        var objectIconPath = MarkerObj.objectIconPath
        if(objectIconPath != undefined){
          switch (objectIconPath.toLowerCase()) {
            case 'cars':
              objectIconPath = 'Car'
              break;
            case 'ambulance':
                objectIconPath = 'ambulance'
                break;
            case 'bus':
                objectIconPath = 'bus'
                break;
            case 'bus2':
                objectIconPath = 'bus2'
                break;
            case 'dumptruck':
                objectIconPath = 'DumpTruck'
                break;
            case 'excavator':
                objectIconPath = 'Excavator'
                break;
            case 'freightliner':
                objectIconPath = 'Freightliner'
                break; 
            case 'grader':
                objectIconPath = 'grader'
                break;
            case 'motorGrader':
                objectIconPath = 'MotorGrader'
                break; 
            case 'people':
                objectIconPath = 'people'
                break; 
            case 'plate':
                objectIconPath = 'Plate'
                break; 
            case 'motocycle':
                objectIconPath = 'Scooter'
                break;  
            case 'trailer':
                objectIconPath = 'trailer'
                break;  
            case 'truck':
                objectIconPath = 'Truck'
                break;        
            default:
                break;
          }
        }
        // console.log(objectIconPath)
        var directionindex = Vue.prototype.$Global.DegreeDirection(MarkerObj.direction)
        div.classList.add("Unitmarkdiv")
        div.innerHTML = `
        <div class="GoogleMarkericoncalss" style="position:relative">
          <img title="`+MarkerObj.identifier+`" style="z-index: 1;position: relative;" src=`+require('../static/images/MapIcon/'+objectIconPath+'/CHead'+directionindex+'_S'+colornum+'.gif')+`>
        </div>
        `
      },
      //新增歷史軌跡camera 點位
      AddCameraMarker(div,MarkerObj){
        div.classList.add("Unitmarkdiv")
        var id= `EventVideo`+MarkerObj.positionLogId
        div.innerHTML =
        `
        <div class="GoogleMarkericoncalss" style="position:relative">
          <div title="Event Video"><i id=`+id+` class="fa fa-camera" style="font-size:20px;position:absolute;top:-22.5px;left:5px;cursor:pointer;color:black;z-index:100"></i></div>
        </div>
        `
        this.AddHistoryCameraEvent(id,MarkerObj)
      },
      //新增追蹤車機 點位
      AddUnitMark(div,MarkerObj){
        div.classList.add("Unitmarkdiv")
        var dotcolor = ''
        if(MarkerObj.connectionState == 0){
          dotcolor = 'style="border-color:red !important"'
        }else{
          switch (MarkerObj.accState) {
            case 0:
              dotcolor = 'style="border-color:blue !important"'
              break;
            case 1:
              dotcolor = 'style="border-color:green !important"'
              if(MarkerObj.State){
                if(MarkerObj.State == 'Idle'){
                  dotcolor = 'style="border-color:#FF8429 !important"'
                }
              }
              break;        
            default:
              break;
          }
        }
        div.innerHTML = 
        `
        <div class="GoogleMarkericoncalss" style="position:relative">
          <div id="dot`+MarkerObj.unitId+`" class="dot" `+dotcolor+`></div>
          <img title="`+MarkerObj.identifier+`" style="z-index: 1;position: relative;" src=`+MarkerObj.UnitImgGroup.Unitimg+`>
        </div>
        `
        div.id = "CarNo_"+MarkerObj.unitId
        this.AddUnitMarkEvent(div.id,MarkerObj)
      },
      //新增追蹤車機點位 click 事件
      AddUnitMarkEvent(UnitMarkID,MarkerObj){
        var this_ =this
        setTimeout(() => {
            Vue.prototype.$("#"+UnitMarkID).click(function(){
              Vue.prototype.$Vehicle.ClickUnitInfo = MarkerObj
              // Vue.prototype.$Vehicle.setUnitVideoShow()
              // Vue.prototype.$Vehicle.setCameraConnection()
              if(MarkerObj.unitId != Vue.prototype.$Vehicle.ClickUnitInfo.unitId){
                Vue.prototype.$Vehicle.CloseVideo()
              }
              //紀錄點選車機資訊
              //console.log(Vue.prototype.$Vehicle.ClickUnitInfo)
              Vue.prototype.$Vehicle.UnitListDetailShow = true //打開UnitDetail
              this_.SetCenter(MarkerObj.latitude,MarkerObj.longitude,Vue.prototype.$Global.FocusZoom)
              setTimeout(() => {
                this_.SetUnitmarkZindex(MarkerObj.unitId)
              }, 250);
              Vue.prototype.$Global.SetDotOn(MarkerObj.unitId)
              if(Vue.prototype.$Global.FreeMode != 'true'){
                //切換為自由模式
                Vue.prototype.$Global.FreeMode = 'true'
                setTimeout(() => {
                  //解除自由模式
                  Vue.prototype.$Global.FreeMode = 'false'
                }, 10000);
              }
              // if(localStorage.getItem('MultiFocusUnitTimeoutID')!=''){
              //   Vue.prototype.$Global.ClearMultiFocusStartMultiFocus()
              // }
            })
          }, 20);
      },
      //地圖車輛浮到最上層
      SetUnitmarkZindex(UnitID){
        Vue.prototype.$(".Unitmarkdiv").css('z-index','auto')
        Vue.prototype.$("#CarNo_"+UnitID).css('z-index','inherit')
        Vue.prototype.$Vehicle.ClickUnitID = UnitID
      },
      //新增量測距離 點位樣式
      AddDistanceMark(div,imgsrc){
        div.classList.add("distancemarkdiv")
        var html = ''
        switch (localStorage.getItem('Unit')) {
          case 'km':
            html = '<div class="px-1 py-1">'+ this.KmArr[this.KmArr.length-1].toString() + Vue.prototype.$Global.Unit + '<br/>' + this.KmTotal[this.KmTotal.length-1].toString() + Vue.prototype.$Global.Unit+'</div>'
            break;
          case 'mi':
            html = '<div class="px-1 py-1">'+ this.MiArr[this.MiArr.length-1].toString() + Vue.prototype.$Global.Unit + '<br/>' + this.MiTotal[this.MiTotal.length-1].toString() + Vue.prototype.$Global.Unit+'</div>'
              break;        
          default:
            break;
        }
        var distancehtml = 
        '<img class="GoogleDistanceMarkericoncalss" src="'+imgsrc+'">'+'<div class="kmmishowdiv">'+html+'</div>'
        div.innerHTML = distancehtml
      },
      //新增POI 點位樣式
      AddPOIMarker(div,Obj){
        div.classList.add("pointmarkdiv")
        var POIhtml = 
        '<img class="GooglePOIMarkericoncalss" src="'+this.POIsrc+'">'+'<div class="pointNamediv ">'+Obj.pointName+'</div>'
        div.innerHTML = POIhtml
      },
      //畫上polyline
      SetPolyPath(Latitude,Longitude){
        if(Latitude == ''){
        }else{
          var latLng = {lat: Latitude, lng: Longitude}
          this.PolylinePoint.push(latLng)
        }
        this.PolyPath.setMap(null)
        this.Initpolyline('blue',this.PolylinePoint)
        this.PolyPath.setMap(this.FMap);
      },
      //畫上里史軌跡polyline and camera點位
      AddHistoryTraceline(Obj){
        if(Obj != ''){
          for(var i=0 ; i<Obj.length ;i++){
            this.HistoryTracelatlngs.push({lat:Obj[i].latitude,lng:Obj[i].longitude})
            //4channel的時候要改
            if(Vue.prototype.$Global.authorityDefine['VD00']){
              for(var j = 1 ; j <=16 ; j++){
                if(Obj[i]['upload'+j] == undefined){
                  break;
                }else if(Obj[i]['upload'+j] != 0){
                  this.AddOverlayMarker(Obj[i].latitude,Obj[i].longitude,'','CameraMarker',Obj[i])
                  break;
                }
              }
            }
            // if(Obj[i].upload1 !=0 || Obj[i].upload2 !=0){
            //   this.AddOverlayMarker(Obj[i].latitude,Obj[i].longitude,'','CameraMarker',Obj[i])
            // }
          }
        }
        if(this.HistoryPolyPath != ''){
          this.HistoryPolyPath.setMap(null)
        }
        this.Initpolyline('red',this.HistoryTracelatlngs,'HistoryPath')
        setTimeout(() => {
          this.HistoryPolyPath.setMap(this.FMap);
        }, 100);
      },
      //刪除歷史軌跡 polyline
      RemoveHistoryTraceline(){
        this.HistoryTracelatlngs = []
        this.AddHistoryTraceline('')
      },
      //初始化 polyline
      Initpolyline(Color,PolylinePoint,Type){
        var PolyPath = new google.maps.Polyline({
          path: PolylinePoint,
          strokeColor: Color,
          strokeOpacity: 1.0,
          strokeWeight: 3,
        });
        if(Type == 'HistoryPath'){
          this.HistoryPolyPath = PolyPath
        }else{
          this.PolyPath = PolyPath
        }
      },
      //刪除 polyline
      RemovePolyPath(){
        this.PolylinePoint = []
        this.KmArr =[]
        this.KmTotal =[]
        this.MiArr =[]
        this.MiTotal =[]
        this.SetPolyPath('','')
      },
      //建立地圖 click 事件
      MapListener:function(){
        this.FMap.addListener("click", (e) => {// Add Marker and PolyLine
          this.AddOverlayMarker(e.latLng.lat(),e.latLng.lng(),require('../static/images/GoogleMapICON/Row1/green-dot.png'),'DistanceMarker')
          this.SetPolyPath(e.latLng.lat(),e.latLng.lng())
          //console.log(e.latLng.lat(),e.latLng.lng())
        });
      },
      //刪除地圖 click 事件
      RemoveclickListen:function(){
        google.maps.event.clearListeners(this.FMap)
      },
      //Google Map 打點
      AddOverlayMarker:function(Latitude,Longitude,imgsrc,Type,MarkerObj){
        // console.log("Latitude:"+Latitude+",Longitude:"+Longitude+",imgsrc:"+imgsrc+",Type:"+Type+",MarkerObj:"+MarkerObj)
        const bounds = new google.maps.LatLngBounds(
          new google.maps.LatLng(Latitude,Longitude),
        );
        //Google map 打點class
        var USGSOverlay = class extends google.maps.OverlayView{
          bounds;
          status;
          div;
          id;
          UnitID;
          MarkerObj;
          panes;
          constructor(bounds,imgsrc,type,MarkerObj,image) {
            //丟值給父類別
            super();
            this.bounds = bounds;
            this.image = image;
            this.type = type;
            this.imgsrc = imgsrc;
            this.MarkerObj = MarkerObj;
          }
          onAdd(state) {
            this.div = document.createElement("div");
            switch (this.type) {
              case 'DistanceMarker':
                Vue.prototype.$GoogleMap.CalculateKmMi()
                Vue.prototype.$GoogleMap.AddDistanceMark(this.div,this.imgsrc)
                Vue.prototype.$GoogleMap.DistanceMarkernum++
                this.id = 'GoogleDistanceMarker'+Vue.prototype.$GoogleMap.DistanceMarkernum
                break;
              case 'UnitMarker':
                Vue.prototype.$GoogleMap.AddUnitMark(this.div,this.MarkerObj)
                break;
              case 'HistoryMark':
                var index = 0
                //找出當下建置的是第幾個資料
                for(var i=0 ; i<Vue.prototype.$History.UnitDateTimeHistoryObj.length ; i++){
                  if(this.MarkerObj.positionLogId == Vue.prototype.$History.UnitDateTimeHistoryObj[i].positionLogId){
                    index = i
                    break;
                  }
                }
                Vue.prototype.$GoogleMap.AddHistoryMark(this.div,this.MarkerObj,index)
                break;
              case 'HistoryACCOnOffMarker':
                var index = 0
                //找出當下建置的是第幾個資料
                for(var i=0 ; i<Vue.prototype.$History.UnitDateTimeHistoryObj.length ; i++){
                  if(this.MarkerObj.positionLogId == Vue.prototype.$History.UnitDateTimeHistoryObj[i].positionLogId){
                    index = i
                    break;
                  }
                }
                Vue.prototype.$GoogleMap.AddHistoryAccOnOffMarker(this.div,this.MarkerObj,index)
                break; 
              case 'HistoryUnitMark':
                Vue.prototype.$GoogleMap.AddHistoryUnitMark(this.div,this.MarkerObj)
                break;   
              case 'CameraMarker':
                Vue.prototype.$GoogleMap.AddCameraMarker(this.div,this.MarkerObj)
                break;
              case 'PointMarker':
                Vue.prototype.$GoogleMap.AddPOIMarker(this.div,this.MarkerObj)
                break;    
              default:
                break;
            }
            this.panes = this.getPanes();
            switch (state) {
              case 'MoveOverlaymarker':
                setTimeout(() => {
                  this.panes.floatPane.appendChild(this.div);
                  Vue.prototype.$GoogleMap.SetCenter(Vue.prototype.$GoogleMap.FMap.center.lat(),Vue.prototype.$GoogleMap.FMap.center.lng()-0.00000000001,Vue.prototype.$GoogleMap.FMap.zoom)
                  Vue.prototype.$GoogleMap.AddUnitMarkEvent("CarNo_"+this.MarkerObj.unitId,this.MarkerObj)
                }, 250);
                break;
              default:
                this.panes.floatPane.appendChild(this.div);
                break;
            }
          }
          draw() {
            const overlayProjection = this.getProjection();
            const sw = overlayProjection.fromLatLngToDivPixel(
              this.bounds.getSouthWest()
            );
            const ne = overlayProjection.fromLatLngToDivPixel(
              this.bounds.getNorthEast()
            );
            if (this.div) {
              this.div.style.left = sw.x + "px";
              this.div.style.top = ne.y + "px";
            }
          }
          onRemove() {
            if (this.div) {
              this.div.parentNode.removeChild(this.div);
              delete this.div;
            }
          }
          MoveOverlaymarker(bounds,Obj){
            this.bounds = bounds
            this.MarkerObj = Obj
            this.panes.floatPane.removeChild(this.div)
            this.onAdd('MoveOverlaymarker')
          }
        }
        //建立overlay instance
        const overlay = new USGSOverlay(bounds,imgsrc,Type,MarkerObj);
        switch (Type) {
          case 'DistanceMarker':
            this.DistanceOverlayMarkers.push(overlay)
            break;
          case 'UnitMarker':
            this.UnitOverlayMarkers.push(overlay)
            break; 
          case 'HistoryMark':
            this.HistoryOverlayMarkers.push(overlay)
            break;
          case 'HistoryACCOnOffMarker':
              this.HistoryAccOverlayMarkers.push(overlay)
            break; 
          case 'HistoryUnitMark':
            this.HistoryUnitMarker.push(overlay)
            break; 
          case 'CameraMarker':
            this.CameraMarkers.push(overlay)
            break; 
          case 'PointMarker':
            this.POIMarkers.push(overlay)
            break;      
          default:
            break;
        }
        //console.log(this.UnitOverlayMarkers)
        //overlay 丟進map中
        overlay.setMap(this.FMap);
      },
      //刪除量測距離點位
      RemoveDistancOverlayMarkers:function(){
        for(var i=0 ; i<this.DistanceOverlayMarkers.length;i++){
          this.DistanceOverlayMarkers[i].onRemove()
        }
        this.DistanceOverlayMarkers = []
        this.DistanceMarkernum = 0
      },
      //刪除車機點位
      RemoveUnitOverlayMarkers:function(){
        for(var i=0 ; i<this.UnitOverlayMarkers.length;i++){
          this.UnitOverlayMarkers[i].onRemove()
        }
        this.UnitOverlayMarkers = []
      },
      //刪除歷史軌跡車機點位
      RemoveHistoryOverlayMarkers:function(){
        for(var i=0 ; i<this.HistoryOverlayMarkers.length;i++){
          this.HistoryOverlayMarkers[i].onRemove()
        }
        this.HistoryOverlayMarkers = []
      },
      //刪除歷史軌跡啟動熄火點位
      RemoveHistoryAccOverlayMarkers:function(){
        for(var i=0 ; i<this.HistoryAccOverlayMarkers.length;i++){
          this.HistoryAccOverlayMarkers[i].onRemove()
        }
        this.HistoryAccOverlayMarkers = []
      },
      //刪除歷史軌跡camera點位
      RemoveCameraOverlayMarkers:function(){
        for(var i=0 ; i<this.CameraMarkers.length;i++){
          this.CameraMarkers[i].onRemove()
        }
        this.CameraMarkers = []
      },
      //刪除追蹤 POI 點位
      RemovePOIOverlayMarkers:function(){
        for(var i=0 ; i<this.POIMarkers.length;i++){
          this.POIMarkers[i].onRemove()
        }
        this.POIMarkers = []
      },
      //刪除點位 通用 function
      RemoveOverlayMarkers:function(Obj){
        for(var i=0 ; i<Obj.length;i++){
          Obj[i].onRemove()
        }
        Obj = []
      },
      //刪除單一Marker
      Removeme:function(object){
        object.onRemove()
      },
      //量測距離開關 建立 click 事件 或 關閉 click事件 
      //按鈕變色
      ClickMapDistance(){
          if(!this.MapclickListen){
            Vue.prototype.$("#mapdistance").addClass('Background-color-green')
            this.MapclickListen = true
            this.MapListener()
          }else{
            Vue.prototype.$("#mapdistance").removeClass('Background-color-green')
            this.MapclickListen = false
            this.RemoveDistancOverlayMarkers()
            this.RemoveclickListen()
            this.RemovePolyPath()
          }
      },
      //新增Geofence圖
      AddGeofence(Obj){
        var Circle;
        var polygon;
        var LatLng;
        this.Circles = []
        this.Polygons = []
        for(var i = 0 ; i < Obj.length;i++){
          switch (Obj[i].geoType) {
            case 'Circle':
              if(Obj[i].geoNodes){
                var geoNodesArr = Obj[i].geoNodes.split(';')      
                var lat = geoNodesArr[0].split(',')[0]
                var lng = geoNodesArr[0].split(',')[1]
                var mradius = geoNodesArr[1]*1000
                LatLng = new google.maps.LatLng(lat, lng);
                Circle = new google.maps.Circle({
                  map: this.FMap,
                  center: LatLng, // LatLng object
                  radius: mradius,     // in meters
                  fillColor: '#3388ff',
                  fillOpacity: 0.35,
                  strokeColor: '#3388ff',
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  title:Obj[i].zoneName
                });
                Circle.setMap(this.FMap);
                const infowindow = new google.maps.InfoWindow({
                  content: '<div style="color:black">'+Obj[i].zoneName+'</div>',
                  position: LatLng,
                });
                google.maps.event.addListener(Circle,'click',function(){
                  infowindow.open(this.FMap,Circle);
                });
                infowindow.open(this.FMap,Circle);
                this.Circles.push(Circle)
              }
              break;
            case 'Polygon':
              var latlngs = []
              if(Obj[i].geoNodes){
                var geoNodes = Obj[i].geoNodes.split(';')
                for(var j=0 ;j<geoNodes.length ; j++){
                  var lat = parseFloat(geoNodes[j].split(',')[0])
                  var lng = parseFloat(geoNodes[j].split(',')[1])
                  latlngs.push({lat, lng})
                }
              }
              // Construct the polygon.
              polygon = new google.maps.Polygon({
                paths: latlngs,
                strokeColor: "#3388ff",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#3388ff",
                fillOpacity: 0.35,
                title:Obj[i].zoneName
              });
              polygon.setMap(this.FMap);
              google.maps.Polygon.prototype.my_getBounds=function(){
                var bounds = new google.maps.LatLngBounds()
                this.getPath().forEach(function(element,index){bounds.extend(element)})
                return bounds
              }
              const infowindow = new google.maps.InfoWindow({
                content: '<div style="color:black">'+Obj[i].zoneName+'</div>',
                position: polygon.my_getBounds().getCenter(),
              });
              google.maps.event.addListener(polygon,'click',function(){
                infowindow.open(this.FMap,polygon);
              });
              infowindow.open(this.FMap,polygon);
              this.Polygons.push(polygon)
              break;
          }
        }
      },
      //刪除Geofence圖
      RemoveGeofence(){
        if(this.Circles.length != 0){
          for(var i = 0 ;i<this.Circles.length;i++){
            this.Circles[i].setMap(null);
          }
        }
        if(this.Polygons.length != 0){
          for(var i = 0 ;i<this.Polygons.length;i++){
            this.Polygons[i].setMap(null);
          }
        }
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/GoogleMap.js